import React from "react";

export const Services: React.FC = () => (
  <section id="services">
    <div className="container">
      <h2 className="section-title">Основные направления</h2>
      <p className="section-subtitle">
        Комплексно закрываем вопросы, связанные с IT-инфраструктурой и
        программным обеспечением. Можно начать с небольшой задачи и постепенно
        масштабировать проект.
      </p>

      <div className="cards">
        <div className="card">
          <h3>Разработка программного обеспечения</h3>
          <p>
            Создаём и развиваем прикладные и инфраструктурные решения под задачи
            бизнеса.
          </p>
          <ul>
            <li>Веб-сервисы, личные кабинеты, панели управления</li>
            <li>Интеграции с CRM/ERP, платёжными и внешними системами</li>
            <li>Автоматизация рутинных процессов и отчётности</li>
          </ul>
        </div>

        <div className="card">
          <h3>Внедрение IT-инфраструктуры</h3>
          <p>
            Подбираем и настраиваем оборудование под существующие и планируемые
            нагрузки.
          </p>
          <ul>
            <li>Рабочие станции, серверы, сетевое оборудование</li>
            <li>Настройка локальной сети, VPN, удалённого доступа</li>
            <li>Облачные сервисы, хранилища, виртуальные серверы</li>
          </ul>
        </div>

        <div className="card">
          <h3>Интеграция оборудования и сервисов</h3>
          <p>Соединяем системы между собой, устраняя “разрывы” в процессах.</p>
          <ul>
            <li>Подключение и настройка периферии и рабочих мест</li>
            <li>Интеграция ПО между собой и с внешними сервисами</li>
            <li>Миграция и консолидация данных, настройка прав доступа</li>
          </ul>
        </div>

        <div className="card">
          <h3>Техническая поддержка и сопровождение</h3>
          <p>
            Поддерживаем стабильную работу решений и оперативно реагируем на
            инциденты.
          </p>
          <ul>
            <li>Регламентные работы и мониторинг ключевых систем</li>
            <li>Резервное копирование и восстановление данных</li>
            <li>Консультации для сотрудников и администраторов</li>
          </ul>
        </div>
      </div>
    </div>
  </section>
);
